<router-outlet></router-outlet>
<!-- No IRA divorce flow -->
@if(!isDivorceTransfer){
    <app-deactivate-modal></app-deactivate-modal>
}